/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Expires_AtInputs */

const en_settings_credits_expires_at = /** @type {(inputs: Settings_Credits_Expires_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires`)
};

const zh_settings_credits_expires_at = /** @type {(inputs: Settings_Credits_Expires_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过期时间`)
};

/**
* | output |
* | --- |
* | "Expires" |
*
* @param {Settings_Credits_Expires_AtInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_expires_at = /** @type {((inputs?: Settings_Credits_Expires_AtInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Expires_AtInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_expires_at(inputs)
	return zh_settings_credits_expires_at(inputs)
});
export { settings_credits_expires_at as "settings.credits.expires_at" }